var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.errors.length > 0)?_c('div',{staticClass:"alert alert-danger",attrs:{"role":"alert"}},[_c('h3',{staticClass:"text-gray-5"},[_vm._v("We found the following errors:")]),_vm._v(" "),_c('ul',{staticClass:"text-gray-5"},_vm._l((_vm.errors),function(error){return _c('li',[_vm._v(_vm._s(error))])}),0)]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }